import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import TopBar from "./TopBar";
import Header, { type PanelKey } from "./Header";
import Footer from "./Footer";
import SearchPanel from "./SearchPanel";
import FavoritesPanel from "./FavoritesPanel";
import CartPanel from "./CartPanel";
import Toast from "./Toast";
import { useStore } from "@/store/StoreContext";
import { WHATSAPP_URL } from "@/mocks/navigation";

export default function AppLayout() {
  const [panel, setPanel] = useState<PanelKey | null>(null);
  const location = useLocation();
  const { toast } = useStore();

  const overlay = location.pathname === "/";

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.pathname]);

  const closePanel = () => setPanel(null);

  return (
    <div id="top" className="flex min-h-screen w-full flex-col bg-background-50">
      <TopBar />
      <Header onOpenPanel={setPanel} overlay={overlay} />

      <main className="w-full flex-1">
        <Outlet />
      </main>

      <Footer />

      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Falar com a gente pelo WhatsApp"
        className="fixed bottom-5 right-4 z-40 flex h-14 w-14 cursor-pointer items-center justify-center rounded-full bg-primary-600 text-background-50 transition-colors hover:bg-primary-700 md:bottom-7 md:right-7"
      >
        <i className="ri-whatsapp-line text-3xl" />
      </a>

      <SearchPanel open={panel === "search"} onClose={closePanel} />
      <FavoritesPanel open={panel === "favorites"} onClose={closePanel} />
      <CartPanel open={panel === "bag"} onClose={closePanel} />
      <Toast message={toast} />
    </div>
  );
}